import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import _ from 'lodash';
import { MenuItem } from '@card-software/library';
import { RolesBootstrapService, Site, SiteBootstrapService, SiteService } from '@card-software/nexus-utilities';
import { GlobalMessageUtil } from '@card-software/nexus-utilities';
import { environment } from '../environments/environment';
import { MENU_ITEMS } from './app-menu';
import { UserAuthenticationService } from './services/user-authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'production-ui';
  isLoginPage = false;
  readonly environment = environment.environment;

  menuItems: MenuItem[] = MENU_ITEMS;

  private router = inject(Router);
  private userAuthenticationService = inject(UserAuthenticationService);
  private messageService = inject(MessageService);
  private siteBootstrapService = inject(SiteBootstrapService);
  private rolesBootstrapService = inject(RolesBootstrapService);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = _.includes(event.url, '/login');
      }
    });
    GlobalMessageUtil.init(this.messageService);
    const token = this.userAuthenticationService.getStoredJwtToken();
    if (!_.isNil(token)) {
      this.siteBootstrapService.initializeSites(token);
      this.rolesBootstrapService.initializeRoles(token);
    }
  }

  get isLoggedIn() {
    return this.userAuthenticationService.isUserAuthenticated;
  }

  get userLite() {
    return this.userAuthenticationService.userLite;
  }

  get userToken() {
    return this.userAuthenticationService.getStoredJwtToken() || '';
  }

  get showSidebar(): boolean {
    const isLoginPage = this.router.url.includes('/login');
    return this.userAuthenticationService.isUserAuthenticated && !isLoginPage;
  }

  get isUnauthorizedPage(): boolean {
    return this.router.url.includes('/unauthorized');
  }

  get sites(): Site[] {
    return SiteService.getSites();
  }

  get selectedSiteId(): string {
    return SiteService.getSelectedSiteId() || '';
  }

  onSiteChanged(siteId: string) {
    SiteService.setSelectedSite(siteId);
  }

  onLogout() {
    this.userAuthenticationService.logout();
  }
}
